import { render, staticRenderFns } from "./sideband.vue?vue&type=template&id=8b83ace6&scoped=true"
import script from "./sideband.vue?vue&type=script&lang=js"
export * from "./sideband.vue?vue&type=script&lang=js"
import style0 from "./sideband.vue?vue&type=style&index=0&id=8b83ace6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b83ace6",
  null
  
)

export default component.exports